// PCBLines.jsx
import React from 'react';

/**
 * Motherboard trace geometry, shared with <EnergyPulse />.
 *
 * Direction matters: input traces are authored from the LEFT margin toward the
 * gear so the animated pulse travels inward; output traces are authored from the
 * gear outward so the pulse travels away. `delay` staggers the energy cascade.
 */
export const TRACES = [
  // ---- inputs (left margin -> centre gear) ----
  { id: 'in-1', kind: 'in', delay: 0.0, d: 'M 0 110 H 64 V 196 H 150 V 244 H 186' },
  { id: 'in-1b', kind: 'in', delay: 0.35, d: 'M 0 150 H 40 V 224 H 150' },
  { id: 'in-2', kind: 'in', delay: 0.15, d: 'M 0 300 H 186' },
  { id: 'in-2b', kind: 'in', delay: 0.5, d: 'M 96 300 V 360 H 168' },
  { id: 'in-3', kind: 'in', delay: 0.25, d: 'M 0 488 H 64 V 392 H 150 V 352 H 186' },

  // ---- outputs (centre gear -> satellite gears) ----
  { id: 'out-up', kind: 'out', delay: 0.0, d: 'M 452 250 H 512 V 188' },
  { id: 'out-dn', kind: 'out', delay: 0.12, d: 'M 452 350 H 512 V 412' },

  // ---- outputs (satellite gears -> right margin / off-board) ----
  { id: 'out-r1', kind: 'out', delay: 0.3, d: 'M 572 116 H 612 V 64 H 640' },
  { id: 'out-r2', kind: 'out', delay: 0.42, d: 'M 572 484 H 612 V 540 H 640' },
  { id: 'out-r3', kind: 'out', delay: 0.2, d: 'M 455 300 H 600 V 322 H 640' },
];

/** Connection nodes / junction pads sitting on the traces. */
export const NODES = [
  { x: 64, y: 196 }, { x: 150, y: 244 }, { x: 40, y: 224 },
  { x: 96, y: 300 }, { x: 96, y: 360 },
  { x: 64, y: 392 }, { x: 150, y: 352 },
  { x: 512, y: 250 }, { x: 512, y: 350 },
  { x: 612, y: 64 }, { x: 612, y: 540 }, { x: 600, y: 322 },
];

/** Larger square solder pads for a more board-like read. */
const PADS = [
  { x: 0, y: 110 }, { x: 0, y: 300 }, { x: 0, y: 488 },
  { x: 640, y: 64 }, { x: 640, y: 540 }, { x: 640, y: 322 },
];

function PCBLines() {
  return (
    <g aria-hidden="true">
      {/* Copper traces — drawn twice for a subtle bevelled edge */}
      {TRACES.map((t) => (
        <g key={t.id}>
          <path d={t.d} fill="none" stroke="#c2cad8" strokeWidth="4" strokeLinejoin="round" strokeLinecap="round" />
          <path d={t.d} fill="none" stroke="#eef1f6" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
        </g>
      ))}

      {/* Junction nodes */}
      {NODES.map((n, i) => (
        <g key={`n-${i}`}>
          <circle cx={n.x} cy={n.y} r="5" fill="#cdd4e0" stroke="#aab2c2" strokeWidth="1" />
          <circle cx={n.x} cy={n.y} r="2" fill="#9aa3b4" />
        </g>
      ))}

      {/* Edge solder pads */}
      {PADS.map((p, i) => (
        <rect
          key={`p-${i}`}
          x={p.x - 7}
          y={p.y - 5}
          width="14"
          height="10"
          rx="2"
          fill="#cdd4e0"
          stroke="#aab2c2"
          strokeWidth="1"
        />
      ))}
    </g>
  );
}

export default React.memo(PCBLines);
